<!--
    Summary:
        firstchoice.exhibition.web - mthfr-p5
    ChangeLog:
        wangn on 2020/12/6 added
-->
<template>
  <div class="v-mthfr-p5" title="mthfr-p5">
    <img-card class="card" has-img>
      <div slot="title" style="width:100%;">{{$t('Mthfr.P5_Title')}}</div>
      <div slot="img" v-if="$i18n.locale=='zh-TCC'">
        <img src="../../../assets/images/mthfr/p5_zh.png"/>
      </div>
      <div slot="img" v-if="$i18n.locale=='zh-CN'">
        <img src="../../../assets/images/mthfr/p5_cn.png"/>
      </div>
      <div slot="img" v-if="$i18n.locale=='en-US'">
        <img src="../../../assets/images/mthfr/p5_en.png"/>
      </div>
      <p>{{$t('Mthfr.P5_Content')}}</p>
    </img-card>
  </div>
</template>

<script>
  import ImgCard from "../img-card";

  export default {
    name: "mthfr-p5",
    components: {ImgCard}
  }
</script>

<style lang="scss">
  .v-mthfr-p5 {
    .v-card-main {
      flex-direction: row-reverse;
    }

    .v-card .v-card-main.avg > div {
      margin-left: 80px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: justify;
      
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/genedetection/mthfr/mthfr-p5.vue